import React, { useEffect, useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import { useSelector } from "react-redux";
import DynamicFilterInput from "../../../../Kryzen Alpha App/Components/layouts/filter.inpit";
import getFilteredURL from "../../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import Pagination from "../../../Components/layouts/pagination";
import { FcBusinessman, FcCamcorder, FcCamcorderPro, FcFilmReel } from "react-icons/fc";
import { BsBoxArrowInDownRight } from "react-icons/bs";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import StepRoutes from "../../../Routes/steps_routes";
import MediaTaskTable from "./media_delivery_table";

const MediaDelivery = () => {
  const user = useSelector((store) => store.login.user);
  const [refresh, setRefresh] = useState(false);
  const store = useSelector((store) => store.login);

  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    taskName: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/mediaDelivery/get-assignTask", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.taskData);
          setTotalPages(Math.ceil(res.data?.totalCount / 50));
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh, page]);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div
                className={
                  store?.user?.Role !==
                  process.env.REACT_APP_ROLE_MARKETING_AGENCY
                    ? "col-md-8"
                    : "col-12"
                }
              >
                <h2 className="page-title mb-1">
                  <FcCamcorderPro className="fs-2 me-1" /> Media Delivery
                </h2>
                <h4 className="text-muted">
                  <StepRoutes></StepRoutes>
                </h4>
              </div>
              {store?.user?.Role !==
                process.env.REACT_APP_ROLE_MARKETING_AGENCY && (
                <div className="col-md-4 d-none d-sm-block">
                  <div className="btn-list justify-content-end">
                    <a href={"/media-task-assign"}>
                      <button className="btn btn-primary">
                        <BsBoxArrowInDownRight className="me-2 fs-2" />
                        ADD MEDIA TASK
                      </button>
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2 ">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0 "
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className={`accordion-body pt-0`}>
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>

                          <div className="col-12">
                            <DynamicFilterInput
                              label="Guest Name:"
                              value={filters.guestName}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  guestName: e.target.value,
                                })
                              }
                              type="text"
                              placeholder="Guest Name"
                            />
                          </div>

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      guestName: "",
                                      startdate: "",
                                      enddate: "",
                                    });
                                    setPage(1);
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block ">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Task Name:"
                              value={filters.taskName}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  taskName: e.target.value,
                                })
                              }
                              type="text"
                              placeholder="Task Name"
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    taskName: "",
                                    startdate: "",
                                    enddate: "",
                                  });
                                  setPage(1);
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {data && (
                  <MediaTaskTable
                    data={data}
                    currentPage={page}
                    itemsPerPage={50}
                  />
                )}

                {
                  <div className="btn-list justify-content-center">
                    <div className="d-lg-none d-md-none mt-3 mb-3">
                      <a href={"/media-task-assign"}>
                        <button className="btn btn-primary">
                          <BsBoxArrowInDownRight className="me-2 fs-2" />
                          ADD MEDIA TASK
                        </button>
                      </a>
                    </div>
                  </div>
                }

                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={data?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default MediaDelivery;
